import React from 'react';
import { apiClient } from './ApiClient';
import { CrudService } from './CrudService';

export const resendInvite = async (inputData: any) => {
  let apiOptions: any = {
    url: 'users/ResendInvite',
    method: 'post',
    data: inputData
  };
  let result = await apiClient.doAction(apiOptions);
  return result;
}

const crudService = CrudService('users');
export const getUsers = async (inputData: any) => { return await crudService.getItems(inputData); }
export const getUserById = async (inputData: any) => { return await crudService.getItemById(inputData); }
export const addUser = async (inputData: any) => { return await crudService.addItem(inputData); }
export const updateUser = async (inputData: any) => { return await crudService.updateItem(inputData); }
export const deleteUser = async (inputData: any) => { return await crudService.deleteItem(inputData); }
export const getLookups = async (inputData: any) => { return await crudService.getLookups(inputData); }
